import BigCTAButton from '../atoms/BigCTAButton';

const HomePageLayout = () => {
  return (
    <div className=' m-auto sm:w-1/2'>
      <div className=''>
        <p className='pb-2 text-xl font-bold'>Welcome to OLPS Catechism!</p>
        <p className='pb-5'>
          Thank you for entrusting your child to us as they begin or continue
          their journey of faith. It is our joy and privilege to walk alongside
          you and your family as your child comes to know the Person of Jesus,
          grows in faith and discovers his/her identity as a beloved child of
          God.
        </p>
        <p className='pb-5'>
          <span className='font-bold'>
            For families registering at OLPS for the first time:
          </span>
          <br />
          Please click <span className='font-bold'>NEW REGISTRATION</span> to
          begin.
        </p>
        <p className='pb-5'>
          <span className='font-bold'>
            For families with children currently attending catechism at OLPS:
          </span>
          <br />
          To register another child for catechism, please click on{' '}
          <span className='font-bold'>Add Another Child</span> and log in using
          your registered mobile number.
        </p>
        <p className='pb-5'>
          We look forward to journeying with you and your family in faith.
        </p>
      </div>

      <div id='homepageCTA'>
        <BigCTAButton
          destination='/preamble'
          title='New Registration'
          body='Register your child for Catechism sessions in 2027'
          testid='new-registration-cta'
        ></BigCTAButton>
        <BigCTAButton
          destination='/register/continue'
          title='Add Another Child'
          body='Include an additional child in your current registration'
          testid='continue-registration-cta'
        ></BigCTAButton>
        <BigCTAButton
          destination='/register/upload'
          title='Upload Documents'
          body='Upload supporting documents for completed registrations.'
          testid='upload-cta'
        ></BigCTAButton>
      </div>

      <div className=' py-4 text-center'>
        Need help?{' '}
        <a
          href='/downloads/Registration-Guide.pdf'
          className=' font-bold text-primary-800'
          target='_new'
        >
          Download the Registration Guide here
        </a>
        .
      </div>
    </div>
  );
};

export default HomePageLayout;
